import { useEffect, useRef, type ReactNode } from 'react'
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/** Rückfrage vor einer Sammelaktion (Not-Aus, Alle fortsetzen, Not-Aus aufheben). Fehler bleibt im Dialog sichtbar. */
export function BestaetigungsDialog({
  offen, titel, beschreibung, children, aktion, gefahr = false, busy, fehler, gesperrt = false, onAbbrechen, onBestaetigen,
}: {
  offen: boolean
  titel: string
  beschreibung: ReactNode
  children?: ReactNode
  aktion: string
  gefahr?: boolean
  busy: boolean
  fehler: string | null
  gesperrt?: boolean
  onAbbrechen: () => void
  onBestaetigen: () => void
}) {
  // Doppelklick-Sperre: `busy` kommt erst nach dem nächsten Render an, bis dahin hält der Ref den zweiten Klick ab.
  const ausgeloest = useRef(false)
  useEffect(() => { if (!busy) ausgeloest.current = false }, [busy, offen])
  const bestaetigen = () => {
    if (ausgeloest.current || busy || gesperrt) return
    ausgeloest.current = true
    onBestaetigen()
  }
  return (
    <Dialog open={offen} onOpenChange={(o) => { if (!o && !busy) onAbbrechen() }}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display">{titel}</DialogTitle>
          <DialogDescription>{beschreibung}</DialogDescription>
        </DialogHeader>
        {children}
        {fehler && <p role="alert" className="rounded-md border border-coral bg-coral-soft px-3 py-2 text-sm text-ink">{fehler}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onAbbrechen} disabled={busy}>Abbrechen</Button>
          <Button
            onClick={bestaetigen}
            disabled={busy || gesperrt}
            className={cn(gefahr && 'bg-coral text-ink hover:bg-coral/90')}
          >
            {aktion}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
